import React from 'react'
import { Menu } from 'components/HoverMenuIcons'
import styled from 'react-emotion'
import { color, shadow } from 'stylist'

const StyledMenu = styled(Menu)`
  position: absolute;
  visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
  top: ${({ show, menuPos }) => (show ? menuPos.top : -1000)}px;
  left: ${({ show, menuPos }) => (show ? menuPos.left : -1000)}px;
  width: 169px;
  padding-top: 4px;
  padding-bottom: 4px;
  background-color: ${color('white')};
  ${shadow('close')};
  transition: opacity 0.75s;
  opacity: ${({ show }) => (show ? 1 : 0)};
  z-index: 1;
`

const MenuRow = styled.span`
  height: 40px;
  padding: 10px 0;
  padding-left: 16px;
  cursor: pointer;

  &:hover {
    background-color: rgba(212, 231, 250, 0.7);
  }
  &.removeFormat > span {
    color: ${color('pewter')};
  }
  &.removeFormat:hover {
    background-color: transparent;
    & > span {
      color: ${color('red')};
    }
  }
`

const MenuIcon = styled.span`
  margin-right: 10px;
  color: ${color('pewter')};
  font-size: 14px;
`

const MenuLabel = styled.span`
  color: ${color('ink')};
  font-size: 14px;
`

const Spacer = styled.div`
  height: 3px;
  margin-top: 7px;
  box-shadow: inset 0 1px 0 0 ${color('silver')};
`

class HoverMenu extends React.Component {
  state = { readyToShow: false }

  constructor(props) {
    super(props)

    this.ref = React.createRef()
  }

  componentDidMount() {
    this.setState({ readyToShow: true })
  }

  render() {
    const { node, targetRef } = this.props

    return (
      <StyledMenu
        className="hover-menu"
        innerRef={this.ref}
        menuPos={getMenuPosition(targetRef.current, this.ref.current)}
        show={this.state.readyToShow}
      >
        {this.props.editor.getHoverMenuButtons(node).map((button, key) => {
          if (button.type === 'spacer') {
            return this.renderSpacer(key)
          } else {
            return this.renderNodeButton(
              button.command,
              button.label,
              button.icon,
              key
            )
          }
        })}
      </StyledMenu>
    )
  }

  renderNodeButton(type, label, icon, key) {
    return (
      <MenuRow
        className={type}
        key={key}
        onMouseDown={ev => this.onClickBlock(ev, type)}
      >
        <MenuIcon className={icon} />
        <MenuLabel>{label}</MenuLabel>
      </MenuRow>
    )
  }

  renderSpacer(key) {
    return <Spacer key={key} />
  }

  onClickBlock(ev, type) {
    ev.preventDefault()

    if (this.props.editor.hasCommand(type)) {
      this.props.editor[type](this.props.node)
    }
  }
}

const getMenuPosition = (target, menu, hOffsetToTarget = 5) => {
  if (!target || !menu) {
    return
  }

  const wrapperPos = window.document
    .getElementById('editor-wrapper')
    .getBoundingClientRect()
  const targetPos = target.getBoundingClientRect()
  const menuTotalWidth = menu.offsetWidth + hOffsetToTarget

  // Not enough room on the left? Place menu on the right
  // Not enough room below? Shift menu up by num pixels past bottom
  return {
    left:
      menuTotalWidth >= targetPos.left
        ? target.offsetWidth + hOffsetToTarget
        : -menuTotalWidth,
    top: Math.min(wrapperPos.bottom - targetPos.top - menu.clientHeight, 0)
  }
}

const HoverMenuPlugin = options => {
  const buttons = new Map()

  return {
    commands: {
      registerHoverMenuButton(editor, command, options) {
        buttons.set(command, {
          command,
          ...options
        })
      }
    },
    queries: {
      getAllHoverMenuButtons(editor) {
        return Array.from(buttons.values())
      },
      getHoverMenuButtons(editor, node) {
        return Array.from(buttons.values()).filter(
          button => !button.show || button.show(node)
        )
      }
    }
  }
}

export { HoverMenu, getMenuPosition }
export default HoverMenuPlugin



// WEBPACK FOOTER //
// ./src/components/Editor/plugins/HoverMenuPlugin.js